import { AmountField } from './AmountField';
import { AutoSuggestions } from './AutoSuggestions';
import { Eligibility } from './Eligibility';
import { Form } from './Form';
import { SubmitButton } from './SubmitButton';

export default { AmountField, AutoSuggestions, Eligibility, Form, SubmitButton };
